import { Fragment, ReactNode } from "react";

import { ContentBlocks } from "blocks/types";
import { usePageContext } from "lib/context/page-context";
import { blockHelpers } from "blocks/utilities";
import { useDragLayer } from "react-dnd";
import { DragTypes } from "lib/react-dnd";
import { ErrorBoundary } from "react-error-boundary";
import { BlockError } from "./BlockError";
import { Block } from "blocks/blocks";
import dynamic from "next/dynamic";

const AddBlockButton = dynamic(() => import("../AddBlockButton"), {
  ssr: false,
  loading() {
    return null;
  },
});

const DRAG_TYPES: Array<string | symbol> = [
  DragTypes.CONTENT_BLOCK,
  DragTypes.NEW_CONTENT_BLOCK_TYPE,
];

export function Blocks(props: {
  blocks: ContentBlocks;
  bare?: boolean;
  parentId?: string;
}) {
  const context = usePageContext();

  const isDragging = useDragLayer((monitor) => {
    const type = monitor.getItemType();
    return type !== null && DRAG_TYPES.includes(type);
  });

  const renderBlocks = () => {
    return props.blocks.map((block, i) => {
      const blockId = blockHelpers.joinIds(props.parentId, i.toString());

      return (
        <ErrorBoundary
          key={i}
          fallbackRender={() => <BlockError blockId={blockId} />}
        >
          <Block block={block} blockId={blockId} />
        </ErrorBoundary>
      );
    });
  };

  function renderAddButton(): ReactNode {
    if (context.isEditing && context.addBlock && !isDragging && !props.bare) {
      return <AddBlockButton onClick={context.addBlock} />;
    }
  }

  return (
    <Fragment>
      {renderBlocks()}
      {renderAddButton()}
    </Fragment>
  );
}
